import { useEffect, useState } from "react";
import { ListingFEService } from "../../services/listing";
import { EUserRole, Listing, WithID } from "../../types/db";
import { applyVariablesToQuery, QueryVariables } from "../../services/db";
import { BaseFirestoreService } from "../../types/services/FirestoreService";

const listingService = new ListingFEService();

/** Takes care of fetching the list of listing from a user */
export const useUserListing = (userId: string, userRole: EUserRole = EUserRole.HOST, root?: boolean) => {
    const [listings, setListings] = useState<WithID<Listing>[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setError(null);//reset error
        setListings([]);//reset list

        if (!userId) return;
        if (userRole === EUserRole.GUEST) return;

        setIsLoading(true);

        const query = applyVariablesToQuery(listingService.getCollection(),
            {
                where: [
                    ...(userRole === EUserRole.HOST ? [{ fieldPath: "host.id", opStr: '==', value: userId }] : []),
                    ...(userRole === EUserRole.COHOST ? [{ fieldPath: "cohost.id", opStr: '==', value: userId }] : []),
                    ...(!!root ? [{ fieldPath: "parent_id", opStr: '==', value: null }] : [])
                ]
            } as QueryVariables
        )

        return query.onSnapshot(
            (querySnapshot) => {
                console.log('onSnapshot', querySnapshot)
                querySnapshot.docChanges().forEach(docChange => {
                    // console.log('changes', docChange)
                    const listing = BaseFirestoreService.documentToEntity<Listing>(docChange.doc);
                    if (!listing) return;//if the listing doesn't exist don't go farther
                    switch (docChange.type) {
                        case 'added':
                            //add to the listings list
                            setListings(curListings => ([...curListings, listing]))
                            break;
                        case 'modified':
                            //modify the listings list
                            setListings(curListings => {
                                return curListings.map(l => (l.id === listing.id) ? listing : l)
                            })
                            break;
                        case 'removed':
                            //delete from the listings list
                            setListings(curListings => {
                                return curListings.filter(l => l.id !== listing.id)
                            })
                            break;
                    }
                })
                setIsLoading(false);
            },
            (error) => {
                setIsLoading(false);
                setError(error.message)
            })
    }, [root, userId, userRole])

    return {
        isLoading,
        isError: !!error,
        error,
        listings
    }
}